import { Ghost, Radio, Globe, Bell } from "lucide-react";

export function Topbar({ overview, wompiStatus, alerts }) {
  const languages = overview?.languages || [];
  const autonomy = overview?.autonomy_pct || 0;
  const criticalAlerts = (alerts || []).filter(a => a.severity === "critical").length;
  const totalAlerts = (alerts || []).length;
  const wompiConnected = wompiStatus?.connected;
  const merchantName = wompiStatus?.merchant_name || "";

  return (
    <div className="topbar" data-testid="topbar">
      <div style={{ display: "flex", alignItems: "center", gap: 24 }}>
        <div className="topbar-logo" data-testid="logo">
          <Ghost size={18} strokeWidth={1.5} style={{ color: "#fff" }} />
          <span>GHOSTBRAND</span>
          <span style={{
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: 9, color: "#71717a",
            letterSpacing: "0.1em", marginLeft: 4
          }}>ENGINE v1.0</span>
        </div>

        <div style={{
          display: "flex", alignItems: "center", gap: 6,
          borderLeft: "1px solid rgba(255,255,255,0.08)", paddingLeft: 16
        }}>
          <div className="pulse-dot" style={{ background: "#34C759" }} />
          <span className="font-mono" style={{ fontSize: 10, color: "#34C759", letterSpacing: "0.1em" }}>
            AUTONOMOUS
          </span>
          <span className="font-mono" style={{ fontSize: 10, color: "#71717a", marginLeft: 4 }}>
            {autonomy}%
          </span>
        </div>

        {/* Alert indicator */}
        {totalAlerts > 0 && (
          <div style={{
            display: "flex", alignItems: "center", gap: 4,
            padding: "3px 8px",
            background: criticalAlerts > 0 ? "rgba(255,59,48,0.1)" : "rgba(255,204,0,0.08)",
            border: `1px solid ${criticalAlerts > 0 ? "rgba(255,59,48,0.25)" : "rgba(255,204,0,0.2)"}`,
            borderRadius: 2
          }} data-testid="alert-count-badge">
            <Bell size={11} strokeWidth={1.5} style={{ color: criticalAlerts > 0 ? "#FF3B30" : "#FFCC00" }} />
            <span className="font-mono" style={{
              fontSize: 9, color: criticalAlerts > 0 ? "#FF3B30" : "#FFCC00"
            }}>
              {totalAlerts} ALERTAS
            </span>
          </div>
        )}
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        {/* Net margin */}
        {overview?.net_margin_pct !== undefined && (
          <div style={{
            display: "flex", alignItems: "center", gap: 4,
            padding: "3px 8px",
            border: "1px solid rgba(255,255,255,0.08)", borderRadius: 2
          }} data-testid="net-margin">
            <span className="font-mono" style={{ fontSize: 9, color: "#71717a" }}>MARGEN</span>
            <span className="font-mono" style={{
              fontSize: 10, color: overview.net_margin_pct > 80 ? "#34C759" : "#FFCC00"
            }}>
              {overview.net_margin_pct}%
            </span>
          </div>
        )}

        <div style={{
          display: "flex", alignItems: "center", gap: 4,
          padding: "3px 8px",
          border: "1px solid rgba(255,255,255,0.08)", borderRadius: 2
        }} data-testid="language-indicator">
          <Globe size={11} strokeWidth={1.5} style={{ color: "#71717a" }} />
          <span className="font-mono" style={{ fontSize: 9, color: "#a1a1aa" }}>
            {languages.map(l => l.toUpperCase()).join(" / ")}
          </span>
        </div>

        <div style={{
          display: "flex", alignItems: "center", gap: 4,
          padding: "3px 8px",
          border: `1px solid ${wompiConnected ? "rgba(52,199,89,0.2)" : "rgba(255,59,48,0.2)"}`,
          borderRadius: 2
        }} data-testid="wompi-status">
          <Radio size={11} strokeWidth={1.5} style={{ color: wompiConnected ? "#34C759" : "#FF3B30" }} />
          <span className="font-mono" style={{ fontSize: 9, color: "#a1a1aa" }}>WOMPI</span>
          <span className="font-mono" style={{ fontSize: 9, color: wompiConnected ? "#34C759" : "#FF3B30" }}>
            {wompiConnected ? "LIVE" : "OFF"}
          </span>
          {merchantName && (
            <span className="font-mono" style={{ fontSize: 8, color: "#52525b" }}>
              {merchantName}
            </span>
          )}
        </div>

        <div style={{
          display: "flex", alignItems: "center", gap: 4,
          padding: "3px 8px",
          background: "rgba(255,255,255,0.02)",
          border: "1px solid rgba(255,255,255,0.08)", borderRadius: 2
        }} data-testid="location-tag">
          <span className="font-mono" style={{ fontSize: 9, color: "#71717a" }}>COL</span>
          <span className="font-mono" style={{ fontSize: 9, color: "#a1a1aa" }}>WORLDWIDE</span>
        </div>
      </div>
    </div>
  );
}
